module.exports = __webpack_public_path__ + "yeni ö.s. 6.jpg?d0fff6b44d8032476ec6bbf6341c1321";


//////////////////
// WEBPACK FOOTER
// ./src/HtmlFiles/img/yeni ö.s. 6.jpg
// module id = 396
// module chunks = 0